import axiosInstance from "../../../config/axios-config";

async function fetchAdminDashboardStats(url, jwtToken, setData) {
  try {
    const response = await axiosInstance.get(url, {
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      },
    });
    
    const data = await response.data;
    
    setData(data);
  } catch (err) {
    // console.error(err);
    setData({});
  }
}



export { fetchAdminDashboardStats };
